/**
 * Limpa a sessão do localStorage.
 *
 * @function
 * @returns {void}
 */
function deleteSession() {
  localStorage.clear("session");
}

/**
 * Verifica se uma senha atende aos requisitos mínimos.
 *
 * @function
 * @param {string} senha - A senha a ser verificada.
 * @returns {string} Uma mensagem contendo os requisitos não atendidos, ou uma string vazia se a senha atender a todos os requisitos.
 */
function verificarSenha(senha) {
  let cssRequisitos =
    "color: #74788d!important;" +
    "font-weight: 500 !important;" +
    "float: left !important;" +
    "font-family: var(--bs-font-sans-serif) !important;" +
    "font-size: 0.9rem !important;" +
    " line-height: 1.5 !important;";
  var requisitos = [
    {
      regex: /[a-z]/,
      mensagem:
        '<p style="' +
        cssRequisitos +
        '">' +
        '<i class="bx bxs-check-circle mr-2 text-orange" style="margin-right:5px !important">' +
        "</i>   A senha deve ter pelo menos uma letra minúscula.</p>",
    },
    {
      regex: /[A-Z]/,
      mensagem:
        '<p style="' +
        cssRequisitos +
        '">' +
        '<i class="bx bxs-check-circle mr-2 text-orange" style="margin-right:5px !important">' +
        "</i>   A senha deve ter pelo menos uma letra maiúscula.</p>",
    },
    {
      regex: /\d/,
      mensagem:
        '<p style="' +
        cssRequisitos +
        '">' +
        '<i class="bx bxs-check-circle mr-2 text-orange" style="margin-right:5px !important">' +
        "</i>   A senha deve ter pelo menos um número.</p>",
    },
    {
      regex: /[!@#$%^&~*+=_(),.?":{}|/<>]/,
      mensagem:
        '<p style="' +
        cssRequisitos +
        '">' +
        '<i class="bx bxs-check-circle mr-2 text-orange" style="margin-right:5px !important">' +
        "</i>   A senha deve ter pelo menos um caractere especial.</p>",
    },
    {
      regex: /^.{8,}$/,
      mensagem:
        '<p style="' +
        cssRequisitos +
        '">' +
        '<i class="bx bxs-check-circle mr-2 text-orange" style="margin-right:5px !important">' +
        "</i>   A senha deve ter pelo menos oito caracteres ao todo.</p>",
    },
  ];

  var resultado = "";
  for (var i = 0; i < requisitos.length; i++) {
    var requisito = requisitos[i];
    if (!requisito.regex.test(senha)) {
      resultado += requisito.mensagem + "<br>";
    }
  }
  return resultado;
}

window.deleteSession = deleteSession;

const Authentication = {
  verificarSenha,
};

export default Authentication;
